import { SBC, SRT } from 'pages/dashboards/v5/constants';

/**
 * Which step the add-trunk page should show.
 *
 * A choice is only worth putting in front of the user when there is something
 * to choose between: one SBCaaS variant makes the service step redundant, and
 * one trunk type makes the type step redundant. The chosen type still shows on
 * the create form either way.
 *
 * @param {object}  params
 * @param {boolean} params.servicesLoaded     False until the company's services are known.
 * @param {boolean} params.hasClassicService
 * @param {boolean} params.hasModernService
 * @param {string?} params.serviceChoice      The variant the user picked, once they have.
 * @param {string?} params.trunkTypeID        Set once a trunk type is settled on.
 * @param {number}  params.classicTrunkTypeCount
 * @returns {'loading'|'redirect-modern'|'service-choice'|'trunk-type'|'form'}
 */
export const resolveTrunkAddStep = ({
    servicesLoaded = false,
    hasClassicService = false,
    hasModernService = false,
    serviceChoice = null,
    trunkTypeID = null,
    classicTrunkTypeCount = 0,
} = {}) => {
    if (trunkTypeID) return 'form';
    if (!servicesLoaded) return 'loading';

    // The modern service has a single trunk type, so there is nothing left to
    // ask once it is the only service on the company.
    if (hasModernService && !hasClassicService) return 'redirect-modern';

    const needsServiceChoice = hasClassicService && hasModernService;
    if (needsServiceChoice && serviceChoice !== SBC) return 'service-choice';

    return classicTrunkTypeCount === 1 ? 'form' : 'trunk-type';
};

/** Where picking a service on the choice step leads. */
export const isModernChoice = (serviceType) => serviceType === SRT;
